/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as ConfiguracoesRouteImport } from './routes/configuracoes'
import { Route as ContratosRouteImport } from './routes/contratos'
import { Route as ControladoriaRouteImport } from './routes/controladoria'
import { Route as DashboardRouteImport } from './routes/dashboard'
import { Route as DrinksRouteImport } from './routes/drinks'
import { Route as EventosRouteImport } from './routes/eventos'
import { Route as GiaRouteImport } from './routes/gia'
import { Route as GoatAiRouteImport } from './routes/goat-ai'
import { Route as InventarioRouteImport } from './routes/inventario'
import { Route as LoginRouteImport } from './routes/login'
import { Route as ModelosRouteImport } from './routes/modelos'
import { Route as OrcamentoRouteImport } from './routes/orcamento'
import { Route as PrimeiroAcessoRouteImport } from './routes/primeiro-acesso'
import { Route as VendasRouteImport } from './routes/vendas'
import { Route as DegustacaoTokenRouteImport } from './routes/degustacao.$token'
import { Route as EventosIndexRouteImport } from './routes/eventos.index'
import { Route as EventosEventoIdRouteImport } from './routes/eventos.$eventoId'
import { Route as OrcamentoIndexRouteImport } from './routes/orcamento.index'
import { Route as OrcamentoSolicitarRouteImport } from './routes/orcamento.solicitar'
import { Route as PosEventoEventoIdRouteImport } from './routes/pos-evento.$eventoId'
import { Route as ContratoDadosTokenRouteImport } from './routes/contrato.dados.$token'
import { Route as ContratoFormEventoIdRouteImport } from './routes/contrato.form.$eventoId'
import { Route as OrcamentoSolicitarIndexRouteImport } from './routes/orcamento.solicitar.index'
import { Route as OrcamentoSolicitarTokenRouteImport } from './routes/orcamento.solicitar.$token'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const ConfiguracoesRoute = ConfiguracoesRouteImport.update({
  id: '/configuracoes',
  path: '/configuracoes',
  getParentRoute: () => rootRouteImport,
} as any)
const ContratosRoute = ContratosRouteImport.update({
  id: '/contratos',
  path: '/contratos',
  getParentRoute: () => rootRouteImport,
} as any)
const ControladoriaRoute = ControladoriaRouteImport.update({
  id: '/controladoria',
  path: '/controladoria',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardRoute = DashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => rootRouteImport,
} as any)
const DrinksRoute = DrinksRouteImport.update({
  id: '/drinks',
  path: '/drinks',
  getParentRoute: () => rootRouteImport,
} as any)
const EventosRoute = EventosRouteImport.update({
  id: '/eventos',
  path: '/eventos',
  getParentRoute: () => rootRouteImport,
} as any)
const GiaRoute = GiaRouteImport.update({
  id: '/gia',
  path: '/gia',
  getParentRoute: () => rootRouteImport,
} as any)
const GoatAiRoute = GoatAiRouteImport.update({
  id: '/goat-ai',
  path: '/goat-ai',
  getParentRoute: () => rootRouteImport,
} as any)
const InventarioRoute = InventarioRouteImport.update({
  id: '/inventario',
  path: '/inventario',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const ModelosRoute = ModelosRouteImport.update({
  id: '/modelos',
  path: '/modelos',
  getParentRoute: () => rootRouteImport,
} as any)
const OrcamentoRoute = OrcamentoRouteImport.update({
  id: '/orcamento',
  path: '/orcamento',
  getParentRoute: () => rootRouteImport,
} as any)
const PrimeiroAcessoRoute = PrimeiroAcessoRouteImport.update({
  id: '/primeiro-acesso',
  path: '/primeiro-acesso',
  getParentRoute: () => rootRouteImport,
} as any)
const VendasRoute = VendasRouteImport.update({
  id: '/vendas',
  path: '/vendas',
  getParentRoute: () => rootRouteImport,
} as any)
const DegustacaoTokenRoute = DegustacaoTokenRouteImport.update({
  id: '/degustacao/$token',
  path: '/degustacao/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const EventosIndexRoute = EventosIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => EventosRoute,
} as any)
const EventosEventoIdRoute = EventosEventoIdRouteImport.update({
  id: '/$eventoId',
  path: '/$eventoId',
  getParentRoute: () => EventosRoute,
} as any)
const OrcamentoIndexRoute = OrcamentoIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => OrcamentoRoute,
} as any)
const OrcamentoSolicitarRoute = OrcamentoSolicitarRouteImport.update({
  id: '/solicitar',
  path: '/solicitar',
  getParentRoute: () => OrcamentoRoute,
} as any)
const PosEventoEventoIdRoute = PosEventoEventoIdRouteImport.update({
  id: '/pos-evento/$eventoId',
  path: '/pos-evento/$eventoId',
  getParentRoute: () => rootRouteImport,
} as any)
const ContratoDadosTokenRoute = ContratoDadosTokenRouteImport.update({
  id: '/contrato/dados/$token',
  path: '/contrato/dados/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const ContratoFormEventoIdRoute = ContratoFormEventoIdRouteImport.update({
  id: '/contrato/form/$eventoId',
  path: '/contrato/form/$eventoId',
  getParentRoute: () => rootRouteImport,
} as any)
const OrcamentoSolicitarIndexRoute = OrcamentoSolicitarIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => OrcamentoSolicitarRoute,
} as any)
const OrcamentoSolicitarTokenRoute = OrcamentoSolicitarTokenRouteImport.update({
  id: '/$token',
  path: '/$token',
  getParentRoute: () => OrcamentoSolicitarRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/configuracoes': typeof ConfiguracoesRoute
  '/contratos': typeof ContratosRoute
  '/controladoria': typeof ControladoriaRoute
  '/dashboard': typeof DashboardRoute
  '/drinks': typeof DrinksRoute
  '/eventos': typeof EventosRouteWithChildren
  '/gia': typeof GiaRoute
  '/goat-ai': typeof GoatAiRoute
  '/inventario': typeof InventarioRoute
  '/login': typeof LoginRoute
  '/modelos': typeof ModelosRoute
  '/orcamento': typeof OrcamentoRouteWithChildren
  '/primeiro-acesso': typeof PrimeiroAcessoRoute
  '/vendas': typeof VendasRoute
  '/degustacao/$token': typeof DegustacaoTokenRoute
  '/eventos/$eventoId': typeof EventosEventoIdRoute
  '/orcamento/solicitar': typeof OrcamentoSolicitarRouteWithChildren
  '/pos-evento/$eventoId': typeof PosEventoEventoIdRoute
  '/eventos/': typeof EventosIndexRoute
  '/orcamento/': typeof OrcamentoIndexRoute
  '/contrato/dados/$token': typeof ContratoDadosTokenRoute
  '/contrato/form/$eventoId': typeof ContratoFormEventoIdRoute
  '/orcamento/solicitar/$token': typeof OrcamentoSolicitarTokenRoute
  '/orcamento/solicitar/': typeof OrcamentoSolicitarIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/configuracoes': typeof ConfiguracoesRoute
  '/contratos': typeof ContratosRoute
  '/controladoria': typeof ControladoriaRoute
  '/dashboard': typeof DashboardRoute
  '/drinks': typeof DrinksRoute
  '/gia': typeof GiaRoute
  '/goat-ai': typeof GoatAiRoute
  '/inventario': typeof InventarioRoute
  '/login': typeof LoginRoute
  '/modelos': typeof ModelosRoute
  '/primeiro-acesso': typeof PrimeiroAcessoRoute
  '/vendas': typeof VendasRoute
  '/degustacao/$token': typeof DegustacaoTokenRoute
  '/eventos/$eventoId': typeof EventosEventoIdRoute
  '/pos-evento/$eventoId': typeof PosEventoEventoIdRoute
  '/eventos': typeof EventosIndexRoute
  '/orcamento': typeof OrcamentoIndexRoute
  '/contrato/dados/$token': typeof ContratoDadosTokenRoute
  '/contrato/form/$eventoId': typeof ContratoFormEventoIdRoute
  '/orcamento/solicitar/$token': typeof OrcamentoSolicitarTokenRoute
  '/orcamento/solicitar': typeof OrcamentoSolicitarIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/configuracoes': typeof ConfiguracoesRoute
  '/contratos': typeof ContratosRoute
  '/controladoria': typeof ControladoriaRoute
  '/dashboard': typeof DashboardRoute
  '/drinks': typeof DrinksRoute
  '/eventos': typeof EventosRouteWithChildren
  '/gia': typeof GiaRoute
  '/goat-ai': typeof GoatAiRoute
  '/inventario': typeof InventarioRoute
  '/login': typeof LoginRoute
  '/modelos': typeof ModelosRoute
  '/orcamento': typeof OrcamentoRouteWithChildren
  '/primeiro-acesso': typeof PrimeiroAcessoRoute
  '/vendas': typeof VendasRoute
  '/degustacao/$token': typeof DegustacaoTokenRoute
  '/eventos/$eventoId': typeof EventosEventoIdRoute
  '/orcamento/solicitar': typeof OrcamentoSolicitarRouteWithChildren
  '/pos-evento/$eventoId': typeof PosEventoEventoIdRoute
  '/eventos/': typeof EventosIndexRoute
  '/orcamento/': typeof OrcamentoIndexRoute
  '/contrato/dados/$token': typeof ContratoDadosTokenRoute
  '/contrato/form/$eventoId': typeof ContratoFormEventoIdRoute
  '/orcamento/solicitar/$token': typeof OrcamentoSolicitarTokenRoute
  '/orcamento/solicitar/': typeof OrcamentoSolicitarIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/configuracoes'
    | '/contratos'
    | '/controladoria'
    | '/dashboard'
    | '/drinks'
    | '/eventos'
    | '/gia'
    | '/goat-ai'
    | '/inventario'
    | '/login'
    | '/modelos'
    | '/orcamento'
    | '/primeiro-acesso'
    | '/vendas'
    | '/degustacao/$token'
    | '/eventos/$eventoId'
    | '/orcamento/solicitar'
    | '/pos-evento/$eventoId'
    | '/eventos/'
    | '/orcamento/'
    | '/contrato/dados/$token'
    | '/contrato/form/$eventoId'
    | '/orcamento/solicitar/$token'
    | '/orcamento/solicitar/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/configuracoes'
    | '/contratos'
    | '/controladoria'
    | '/dashboard'
    | '/drinks'
    | '/gia'
    | '/goat-ai'
    | '/inventario'
    | '/login'
    | '/modelos'
    | '/primeiro-acesso'
    | '/vendas'
    | '/degustacao/$token'
    | '/eventos/$eventoId'
    | '/pos-evento/$eventoId'
    | '/eventos'
    | '/orcamento'
    | '/contrato/dados/$token'
    | '/contrato/form/$eventoId'
    | '/orcamento/solicitar/$token'
    | '/orcamento/solicitar'
  id:
    | '__root__'
    | '/'
    | '/configuracoes'
    | '/contratos'
    | '/controladoria'
    | '/dashboard'
    | '/drinks'
    | '/eventos'
    | '/gia'
    | '/goat-ai'
    | '/inventario'
    | '/login'
    | '/modelos'
    | '/orcamento'
    | '/primeiro-acesso'
    | '/vendas'
    | '/degustacao/$token'
    | '/eventos/$eventoId'
    | '/orcamento/solicitar'
    | '/pos-evento/$eventoId'
    | '/eventos/'
    | '/orcamento/'
    | '/contrato/dados/$token'
    | '/contrato/form/$eventoId'
    | '/orcamento/solicitar/$token'
    | '/orcamento/solicitar/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  ConfiguracoesRoute: typeof ConfiguracoesRoute
  ContratosRoute: typeof ContratosRoute
  ControladoriaRoute: typeof ControladoriaRoute
  DashboardRoute: typeof DashboardRoute
  DrinksRoute: typeof DrinksRoute
  EventosRoute: typeof EventosRouteWithChildren
  GiaRoute: typeof GiaRoute
  GoatAiRoute: typeof GoatAiRoute
  InventarioRoute: typeof InventarioRoute
  LoginRoute: typeof LoginRoute
  ModelosRoute: typeof ModelosRoute
  OrcamentoRoute: typeof OrcamentoRouteWithChildren
  PrimeiroAcessoRoute: typeof PrimeiroAcessoRoute
  VendasRoute: typeof VendasRoute
  DegustacaoTokenRoute: typeof DegustacaoTokenRoute
  PosEventoEventoIdRoute: typeof PosEventoEventoIdRoute
  ContratoDadosTokenRoute: typeof ContratoDadosTokenRoute
  ContratoFormEventoIdRoute: typeof ContratoFormEventoIdRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/configuracoes': {
      id: '/configuracoes'
      path: '/configuracoes'
      fullPath: '/configuracoes'
      preLoaderRoute: typeof ConfiguracoesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/contratos': {
      id: '/contratos'
      path: '/contratos'
      fullPath: '/contratos'
      preLoaderRoute: typeof ContratosRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/controladoria': {
      id: '/controladoria'
      path: '/controladoria'
      fullPath: '/controladoria'
      preLoaderRoute: typeof ControladoriaRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard': {
      id: '/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof DashboardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/drinks': {
      id: '/drinks'
      path: '/drinks'
      fullPath: '/drinks'
      preLoaderRoute: typeof DrinksRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/eventos': {
      id: '/eventos'
      path: '/eventos'
      fullPath: '/eventos'
      preLoaderRoute: typeof EventosRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/gia': {
      id: '/gia'
      path: '/gia'
      fullPath: '/gia'
      preLoaderRoute: typeof GiaRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/goat-ai': {
      id: '/goat-ai'
      path: '/goat-ai'
      fullPath: '/goat-ai'
      preLoaderRoute: typeof GoatAiRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/inventario': {
      id: '/inventario'
      path: '/inventario'
      fullPath: '/inventario'
      preLoaderRoute: typeof InventarioRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/modelos': {
      id: '/modelos'
      path: '/modelos'
      fullPath: '/modelos'
      preLoaderRoute: typeof ModelosRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/orcamento': {
      id: '/orcamento'
      path: '/orcamento'
      fullPath: '/orcamento'
      preLoaderRoute: typeof OrcamentoRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/primeiro-acesso': {
      id: '/primeiro-acesso'
      path: '/primeiro-acesso'
      fullPath: '/primeiro-acesso'
      preLoaderRoute: typeof PrimeiroAcessoRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/vendas': {
      id: '/vendas'
      path: '/vendas'
      fullPath: '/vendas'
      preLoaderRoute: typeof VendasRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/degustacao/$token': {
      id: '/degustacao/$token'
      path: '/degustacao/$token'
      fullPath: '/degustacao/$token'
      preLoaderRoute: typeof DegustacaoTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/eventos/': {
      id: '/eventos/'
      path: '/'
      fullPath: '/eventos/'
      preLoaderRoute: typeof EventosIndexRouteImport
      parentRoute: typeof EventosRoute
    }
    '/eventos/$eventoId': {
      id: '/eventos/$eventoId'
      path: '/$eventoId'
      fullPath: '/eventos/$eventoId'
      preLoaderRoute: typeof EventosEventoIdRouteImport
      parentRoute: typeof EventosRoute
    }
    '/orcamento/': {
      id: '/orcamento/'
      path: '/'
      fullPath: '/orcamento/'
      preLoaderRoute: typeof OrcamentoIndexRouteImport
      parentRoute: typeof OrcamentoRoute
    }
    '/orcamento/solicitar': {
      id: '/orcamento/solicitar'
      path: '/solicitar'
      fullPath: '/orcamento/solicitar'
      preLoaderRoute: typeof OrcamentoSolicitarRouteImport
      parentRoute: typeof OrcamentoRoute
    }
    '/pos-evento/$eventoId': {
      id: '/pos-evento/$eventoId'
      path: '/pos-evento/$eventoId'
      fullPath: '/pos-evento/$eventoId'
      preLoaderRoute: typeof PosEventoEventoIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/contrato/dados/$token': {
      id: '/contrato/dados/$token'
      path: '/contrato/dados/$token'
      fullPath: '/contrato/dados/$token'
      preLoaderRoute: typeof ContratoDadosTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/contrato/form/$eventoId': {
      id: '/contrato/form/$eventoId'
      path: '/contrato/form/$eventoId'
      fullPath: '/contrato/form/$eventoId'
      preLoaderRoute: typeof ContratoFormEventoIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/orcamento/solicitar/': {
      id: '/orcamento/solicitar/'
      path: '/'
      fullPath: '/orcamento/solicitar/'
      preLoaderRoute: typeof OrcamentoSolicitarIndexRouteImport
      parentRoute: typeof OrcamentoSolicitarRoute
    }
    '/orcamento/solicitar/$token': {
      id: '/orcamento/solicitar/$token'
      path: '/$token'
      fullPath: '/orcamento/solicitar/$token'
      preLoaderRoute: typeof OrcamentoSolicitarTokenRouteImport
      parentRoute: typeof OrcamentoSolicitarRoute
    }
  }
}

interface EventosRouteChildren {
  EventosEventoIdRoute: typeof EventosEventoIdRoute
  EventosIndexRoute: typeof EventosIndexRoute
}

const EventosRouteChildren: EventosRouteChildren = {
  EventosEventoIdRoute: EventosEventoIdRoute,
  EventosIndexRoute: EventosIndexRoute,
}

const EventosRouteWithChildren =
  EventosRoute._addFileChildren(EventosRouteChildren)

interface OrcamentoSolicitarRouteChildren {
  OrcamentoSolicitarTokenRoute: typeof OrcamentoSolicitarTokenRoute
  OrcamentoSolicitarIndexRoute: typeof OrcamentoSolicitarIndexRoute
}

const OrcamentoSolicitarRouteChildren: OrcamentoSolicitarRouteChildren = {
  OrcamentoSolicitarTokenRoute: OrcamentoSolicitarTokenRoute,
  OrcamentoSolicitarIndexRoute: OrcamentoSolicitarIndexRoute,
}

const OrcamentoSolicitarRouteWithChildren =
  OrcamentoSolicitarRoute._addFileChildren(OrcamentoSolicitarRouteChildren)

interface OrcamentoRouteChildren {
  OrcamentoSolicitarRoute: typeof OrcamentoSolicitarRouteWithChildren
  OrcamentoIndexRoute: typeof OrcamentoIndexRoute
}

const OrcamentoRouteChildren: OrcamentoRouteChildren = {
  OrcamentoSolicitarRoute: OrcamentoSolicitarRouteWithChildren,
  OrcamentoIndexRoute: OrcamentoIndexRoute,
}

const OrcamentoRouteWithChildren = OrcamentoRoute._addFileChildren(
  OrcamentoRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  ConfiguracoesRoute: ConfiguracoesRoute,
  ContratosRoute: ContratosRoute,
  ControladoriaRoute: ControladoriaRoute,
  DashboardRoute: DashboardRoute,
  DrinksRoute: DrinksRoute,
  EventosRoute: EventosRouteWithChildren,
  GiaRoute: GiaRoute,
  GoatAiRoute: GoatAiRoute,
  InventarioRoute: InventarioRoute,
  LoginRoute: LoginRoute,
  ModelosRoute: ModelosRoute,
  OrcamentoRoute: OrcamentoRouteWithChildren,
  PrimeiroAcessoRoute: PrimeiroAcessoRoute,
  VendasRoute: VendasRoute,
  DegustacaoTokenRoute: DegustacaoTokenRoute,
  PosEventoEventoIdRoute: PosEventoEventoIdRoute,
  ContratoDadosTokenRoute: ContratoDadosTokenRoute,
  ContratoFormEventoIdRoute: ContratoFormEventoIdRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
